/**
 * TypingIndicator Component
 * Animating dots to show admin is typing
 * Theme-aware with Tailwind dark: prefix classes
 */

export const TypingIndicator: React.FC = () => {
  return (
    <div className="flex items-end gap-1.5 p-3 rounded-lg max-w-xs w-fit bg-gray-100 dark:bg-gray-700">
      <div
        className="w-2 h-2 rounded-full animate-bounce bg-gray-400 dark:bg-gray-500"
        style={{ animationDelay: '0ms' }}
      />
      <div
        className="w-2 h-2 rounded-full animate-bounce bg-gray-400 dark:bg-gray-500"
        style={{ animationDelay: '150ms' }}
      />
      <div
        className="w-2 h-2 rounded-full animate-bounce bg-gray-400 dark:bg-gray-500"
        style={{ animationDelay: '300ms' }}
      />
    </div>
  );
};